import { Pipe, PipeTransform } from '@angular/core';

import { PropertyType } from '@ap/ap-interface-apix-hypotheken-berekening';

@Pipe({
    name: 'propertyTypePipe',
    standalone: true
})
export class PropertyTypePipe implements PipeTransform {
    transform(contentKey: string, propertyType: PropertyType): string {
        if (propertyType === PropertyType.NEW_BUILD) {
            return `property.transform.new-build.${contentKey}`;
        }
        return `property.transform.existing-build.${contentKey}`;
    }
}
